"use client";

import Clarity from "@microsoft/clarity";
import { useEffect } from "react";

export const ClarityProvider = () => {
  useEffect(() => {
    if (typeof window !== "undefined") {
      if (window.location.hostname !== "localhost") {
        Clarity.init("t08p11aayj");
      }
    }
  });

  return <></>;
};
